import type * as React from 'react';
import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import type { GroundingCommandBarProps, GroundingCommandBarState } from './GroundingCommandBar.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingCommandBar.
 *
 * The returned state can be modified with hooks such as useGroundingCommandBarStyles_unstable,
 * before being passed to renderGroundingCommandBar_unstable.
 *
 * @param props - props from this instance of GroundingCommandBar
 * @param ref - reference to root HTMLElement of GroundingCommandBar
 */
export const useGroundingCommandBar_unstable = (
  props: GroundingCommandBarProps,
  ref: React.Ref<HTMLDivElement>,
): GroundingCommandBarState => {
  return {
    components: {
      root: 'div',
    },
    root: slot.always(
      getIntrinsicElementProps('div', {
        ref,
        ...props,
      }),
      { elementType: 'div' },
    ),
  };
};
